export enum EndPointSignature {
  // ServiceUrl = "localhost:8080/authentication/",
  // AuthenticateUser = "http://localhost:8080/authentication/auth/users/authenticate",
  // ValidateToken = "http://localhost:8080/authentication/auth/token/validate",
  // LogoutUser = "http://localhost:8080/authentication/auth/users/logout",
  // ChangePassword = "http://localhost:8080/authentication/auth/users/$userId/changePassword",
  // ForgotPassword = "http://localhost:8080/authentication/auth/users/forgotPassword",
  // ResetPassword = "http://localhost:8080/authentication/auth/users/resetPassword",
  // UserActivate = "http://localhost:8080/authentication/auth/users/activate",

  // ServiceUrl = 'auth.investingchannel.com/',
  // AuthenticateUser = 'https://auth.investingchannel.com/auth/users/authenticate',
  // ValidateToken = 'https://auth.investingchannel.com/auth/token/validate',
  // LogoutUser = 'https://auth.investingchannel.com/auth/users/logout',
  // ChangePassword = 'https://auth.investingchannel.com/auth/users/$userId/changePassword',
  // ForgotPassword = 'https://auth.investingchannel.com/auth/users/forgotPassword',
  // ResetPassword = 'https://auth.investingchannel.com/auth/users/resetPassword',
  // UserActivate = 'https://auth.investingchannel.com/auth/users/activate',

  ServiceUrl = "stgauth.investingchannel.com/",
  AuthenticateUser = "https://stgauth.investingchannel.com/auth/users/authenticate",
  ValidateToken = "https://stgauth.investingchannel.com/auth/token/validate",
  LogoutUser = "https://stgauth.investingchannel.com/auth/users/logout",
  ChangePassword = "https://stgauth.investingchannel.com/auth/users/$userId/changePassword",
  ForgotPassword = "https://stgauth.investingchannel.com/auth/users/forgotPassword",
  ResetPassword = "https://stgauth.investingchannel.com/auth/users/resetPassword",
  UserActivate = "https://stgauth.investingchannel.com/auth/users/activate",


  // ServiceUrl = "stgauthui.investingchannel.com/",
  // AuthenticateUser = "https://stgauthui.investingchannel.com/auth/users/authenticate",
  // ValidateToken = "https://stgauthui.investingchannel.com/auth/token/validate",
  // LogoutUser = "https://stgauthui.investingchannel.com/auth/users/logout",
  // ChangePassword = "https://stgauthui.investingchannel.com/auth/users/$userId/changePassword",
  // ForgotPassword = "https://stgauthui.investingchannel.com/auth/users/forgotPassword",
  // ResetPassword = "https://stgauthui.investingchannel.com/auth/users/resetPassword",
  // UserActivate = "https://stgauthui.investingchannel.com/auth/users/activate",
}
